<div *ngIf="showForm && !region" class="main-page container">
  <fc-bread-crumb-navigation
    [navigationString]="'Manage Info / Regions / Add a New Region'"></fc-bread-crumb-navigation>
  <h1>Add a New Region</h1>
  <div class="main-panel">
    <form [formGroup]="regionForm" fcFormUnloadWarning>
      <div class="form-container">
        <div class="fields">
          <p>1. Give this Region a name and refresh date</p>
          <mat-form-field>
            <mat-label>Region Name</mat-label>
            <input formControlName="name" id="name" matInput type="text" />
          </mat-form-field>
          <fc-datepicker
            formControlName="refreshDate"
            formFieldClass="upload-region-datepicker"
            inputID="dateOfRegionRefresh"
            label="Refresh Date"></fc-datepicker>

          <p>2. Upload a .kml or .kmz map to define the Region</p>
          <button (click)="onClickKmlUpload()" class="kml-button" mat-button type="button">
            <fa-icon [icon]="['far', 'upload']" class="blue"></fa-icon>
            <span>Upload .kml or .kmz</span>
          </button>
          <ng-container *ngIf="kmlFileName">
            <p>File: {{ kmlFileName }}</p>
          </ng-container>

          <p>3. Upload the Yield Curves associated with this Region</p>
          <button (click)="onClickYieldCurveUpload()" class="yield-curve-button" mat-button type="button">
            <fa-icon [icon]="['far', 'upload']" class="blue"></fa-icon>
            <span>Upload .csv</span>
          </button>
          <ng-container *ngIf="csvFileName">
            <p>File: {{ csvFileName }}</p>
          </ng-container>
          <div *ngIf="errorMessage" class="message-error">
            {{ errorMessage }}
          </div>
          <ng-container *ngIf="csvYieldCurve">
            <div class="yieldCurveTable">
              <table aria-describedby="CSV Yield Curve Table">
                <thead>
                <tr>
                  <th scope="col">Strata Name</th>
                  <th *ngFor="let item of csvYieldCurve[0].getYearArrayAsArray(); let index = index" scope="col">
                    Year {{ index + 1 }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of csvYieldCurve">
                  <th scope="col">{{ row.strata }}</th>
                  <td *ngFor="let item of row.getYearArrayAsArray(); let index = index">
                    {{ item }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <button
            (click)="onSubmit()"
            [disabled]="regionForm.invalid"
            class="button"
            color="primary"
            data-cy="create-region-button"
            mat-raised-button>
            Create Region
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div *ngIf="!showForm && region" class="main-page container">
  <fc-bread-crumb-navigation [navigationString]="'Manage Info / Regions / Region Detail'"></fc-bread-crumb-navigation>
  <div *ngIf="region">
    <div class="heading-row">
      <h1>{{ region.name }}</h1>
    </div>

    <mat-divider></mat-divider>

    <div class="main-panel">
      <div class="fields">
        <h2>Region Overview</h2>
        <div>Region Name: {{ region.name }}</div>
        <div>Refresh Date: {{ regionRefreshDate }}</div>

        <mat-divider [ngStyle]="{ 'margin-top': '25px' }"></mat-divider>

        <div class="heading-row">
          <h2>Yield Curve Within Region</h2>
        </div>

        <ng-container *ngIf="region.yieldCurves">
          <div>Version {{ versionedYieldCurves[0][0].version }}</div>
          <div class="yield-curve-table">
            <table aria-describedby="Current Yield Curve Table">
              <thead>
              <tr>
                <th scope="col">Strata Name</th>
                <th
                  *ngFor="let item of versionedYieldCurves[0][0].getYearArrayAsArray(); let index = index"
                  scope="col">
                  Year {{ index + 1 }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let row of region.versionedYieldCurves(versionedYieldCurves[0][0].version)">
                <th scope="col">{{ row.strata }}</th>
                <td *ngFor="let item of row.getYearArrayAsArray(); let index = index">
                  {{ item }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
      <button
        (click)="onClickEdit()"
        *ngIf="currentUser && currentUser.hasRole(roles.SuperAdmin)"
        color="primary"
        data-cy="edit-button"
        mat-stroked-button>
        Edit
      </button>
    </div>
  </div>
</div>

<div *ngIf="showForm && region" class="main-page">
  <fc-bread-crumb-navigation [navigationString]="'Manage Info / Regions / Update Region'"></fc-bread-crumb-navigation>
  <h1>Update {{ region.name }}</h1>
  <div class="main-panel">
    <form [formGroup]="regionForm">
      <div class="form-container">
        <div class="fields">
          <p>1. Give this Region a name and refresh date</p>
          <mat-form-field>
            <mat-label>Region Name</mat-label>
            <input formControlName="name" id="name" matInput type="text" />
          </mat-form-field>
          <fc-datepicker
            formControlName="refreshDate"
            formFieldClass="upload-region-datepicker"
            inputID="dateOfRegionRefresh"
            label="Refresh Date"></fc-datepicker>

          <p>2. Upload a new .kml or .kmz map to update the Region</p>
          <button (click)="onClickKmlUpload()" class="kml-button" mat-button type="button">
            <fa-icon [icon]="['far', 'upload']" class="blue"></fa-icon>
            <span>Update .kml or .kmz</span>
          </button>
          <ng-container *ngIf="kmlFileName">
            <p>File: {{ kmlFileName }}</p>
          </ng-container>

          <p>3. Upload new Yield Curves associated with this Region</p>
          <button (click)="onClickYieldCurveUpload()" class="yield-curve-button" mat-button type="button">
            <fa-icon [icon]="['far', 'upload']" class="blue"></fa-icon>
            <span>Upload .csv</span>
          </button>
          <ng-container *ngIf="csvFileName">
            <p>File: {{ csvFileName }}</p>
          </ng-container>
          <div *ngIf="errorMessage" class="message-error">
            {{ errorMessage }}
          </div>
          <ng-container *ngIf="csvYieldCurve">
            <div>Version to Upload</div>
            <div class="yield-curve-table">
              <table aria-describedby="New Region Yield Curve Table">
                <thead>
                <tr>
                  <th scope="col">Strata Name</th>
                  <th *ngFor="let item of csvYieldCurve[0].getYearArrayAsArray(); let index = index" scope="col">
                    Year {{ index + 1 }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of csvYieldCurve">
                  <th scope="col">{{ row.strata }}</th>
                  <td *ngFor="let item of row.getYearArrayAsArray(); let index = index">
                    {{ item }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <ng-container *ngIf="region.yieldCurves">
            <div>Version {{ versionedYieldCurves[0][0].version }}</div>
            <div class="yield-curve-table">
              <table aria-describedby="Current Yield Curve Table">
                <thead>
                <tr>
                  <th scope="col">Strata Name</th>
                  <th
                    *ngFor="let item of versionedYieldCurves[0][0].getYearArrayAsArray(); let index = index"
                    scope="col">
                    Year {{ index + 1 }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of region.versionedYieldCurves(versionedYieldCurves[0][0].version)">
                  <th scope="col">{{ row.strata }}</th>
                  <td *ngFor="let item of row.getYearArrayAsArray(); let index = index">
                    {{ item }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <button
            (click)="onSubmitUpdate()"
            [disabled]="disableUploadButton()"
            class="button"
            color="primary"
            mat-raised-button>
            Update Region
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<input #regionFileUpload accept=".kml,.kmz" hidden id="regionFileUpload" name="regionFileUpload" type="file" />

<input #yieldCurveFileUpload accept=".csv" hidden id="yieldCurveFileUpload" name="yieldCurveFileUpload" type="file" />
